import React from 'react';
import SquareAtom from './square';
import styled from '@emotion/styled/macro';
import vars from '@variables';
import { generateKey } from '@utils/utils';
import { PAtom } from '@atoms/text-atoms/text-atoms';
import { VisulisationTableProps } from './visulalisation-table.types';

const VisualisationTable: React.FC<VisulisationTableProps> = ({
  data,
  className,
}) => {
  if (Array.isArray(data)) {
    return (
      <div className={className} data-testid="visualisation-table">
        {data.map(({ value, label, colour }, index) => {
          const percentage = value + '%';
          return (
            <div className="table-row" key={generateKey(label, index)}>
              <div className="data-label">
                {colour ? <SquareAtom colour={colour} /> : null}
                <PAtom>{label}</PAtom>
              </div>
              <div className="data-percent-value">
                {value ? <PAtom>{percentage}</PAtom> : <PAtom>-</PAtom>}
              </div>
            </div>
          );
        })}
      </div>
    );
  } else {
    console.warn(
      `Visualisation Table component called with falsy prop. data: ${data}`
    );
    return null;
  }
};

const StyledVisualisationTable = styled(VisualisationTable)`
  width: 54rem;
  border-bottom: 1px solid ${vars.borderGrey};

  ${PAtom} {
    margin: 1px;
    ${vars.fontSize2}
  }
  .table-row {
    display: flex;
  }

  .data-label {
    display: flex;
    border-top: 1px solid ${vars.borderGrey};
    border-right: 1px solid ${vars.borderGrey};
    border-left: 1px solid ${vars.borderGrey};
    flex-basis: 75%;
    align-items: center;
    padding: ${vars.spacingXs};
  }

  .data-percent-value {
    display: flex;
    justify-content: flex-end;
    border-top: 1px solid ${vars.borderGrey};
    border-right: 1px solid ${vars.borderGrey};
    flex-basis: 25%;
    padding: ${vars.spacingXs};
  }
`;

export default StyledVisualisationTable;
